export const PROJECT_CODE_ALREADY_EXISTS = 'A project with this code already exists in the same company'

// PLAN SUBSCRIPTION
export const CAN_NOT_BE_CANCELED_THE_PLAN_BY_USER_ACTIVE = 'The plan cannot be canceled as it exceeds 2 active users.'

// USERS
export const EXCEDED_THE_MAXIMUN_NUMBER_OF_THE_ACTIVE_USER = 'You have exceeded the maximum number'
export const EMAIL_ALREATY_EXISTS = 'This email is already being used, please try another one'
